import { styled, Box } from "@mui/material";
import {
    SectionWrapper,
    TitleWrapper,
} from "../../../styles/sectionStyles";
import ReactPlayer from "react-player";
import { useEffect } from "react";


const MachineContainer = styled(Box)(({ theme }) => ({
    display: "flex",
    alignSelf: "center",
    "& img": {
        width: 400,
        [theme.breakpoints.down("sm")]: {
            width: 350,
        },
    },
    [theme.breakpoints.down("md")]: {
        flexDirection: "column",
    },
}));

const DetailsWrapper = styled(Box)(({ theme }) => ({
    fontSize: 16,
    marginLeft: 15,
    "& .actions": {
        margin: "12px 0",
    },
    [theme.breakpoints.down("md")]: {
        margin: "10px 0 0 0",
    },
}));
export const Machines = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <SectionWrapper>
            <TitleWrapper>My machine: Macbook Pro 13 inch Touchbar</TitleWrapper>
            <MachineContainer>
                <ReactPlayer
                    url="https://www.apple.com/105/media/us/macbook-pro-13/2020/f2b14406-42ad-405e-bfa0-71b52a0bfd67/anim/hero/large_2x.mp4"
                    autoplay
                    width="100%"
                    playing={true} // autoplay
                // loop
                />
                <DetailsWrapper>
                    
                </DetailsWrapper>
            </MachineContainer>
        </SectionWrapper>
    );
};
